var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Event Details ")]),_c('v-card-text',[_c('v-tiptap',{attrs:{"toolbar":_vm.argTypes,"outlined":""},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.submit}},[_vm._v(" Save event details ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }